var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.permissionIsEnabled("action_log:search")
        ? _c("dash-filter", {
            attrs: {
              options: _vm.filterOptions,
              default: _vm.queryString,
              action: _vm.action,
            },
            model: {
              value: _vm.queryString,
              callback: function ($$v) {
                _vm.queryString = $$v
              },
              expression: "queryString",
            },
          })
        : _vm._e(),
      _c(
        "div",
        [
          _c(
            "emd-card",
            { staticClass: "_footer_spaced_sm" },
            [
              _c("emd-card-header", [
                _c("h2", { staticClass: "emd-text _size_section" }, [
                  _vm._v(" " + _vm._s(_vm.$t("log-actions.list.title")) + " "),
                ]),
              ]),
              _c(
                "emd-card-content",
                { attrs: { customClass: "eu-no-padding" } },
                [
                  _vm.loadingList
                    ? _c(
                        "div",
                        { staticClass: "eu-pa_6 eu-align_center" },
                        [_c("emd-loader", { attrs: { type: "_invert" } })],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _vm.showWarning() && !_vm.closeWarning
                            ? _c(
                                "div",
                                { staticClass: "emd-container__content" },
                                [
                                  _c(
                                    "emd-alert",
                                    {
                                      attrs: {
                                        variant: "warning",
                                        autoclose: false,
                                      },
                                      on: {
                                        cancel: function ($event) {
                                          _vm.closeWarning = true
                                        },
                                      },
                                    },
                                    [
                                      _c("template", { slot: "content" }, [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("log-actions.list.warning")
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._l(_vm.logActions.items, function (log, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "emd-card-grid" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "emd-card-grid__content" },
                                  [
                                    _c("div", { staticClass: "eu-clearfix" }, [
                                      _c(
                                        "div",
                                        { staticClass: "eu-float_left" },
                                        [
                                          _c(
                                            "h2",
                                            {
                                              staticClass:
                                                "emd-text _type_caption eu-pb_2 eu-pr_2 eu_no_padding_sm",
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(log.action) + " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "eu-float_left_mobile eu-float_right",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "emd-badge _color_info",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("dateFormat")(
                                                    log.timestamp,
                                                    "dateAndHour"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    Object.entries(log.metadata).length
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "emd-card-grid__content",
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "emd-text _type_label _size_tiny _color_nonessential",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "log-actions.list.changes"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "eu-mt_1" },
                                              [
                                                _c(
                                                  "pre",
                                                  {
                                                    staticClass:
                                                      "ccg-scrollbar _fixed",
                                                  },
                                                  [_vm._v(_vm._s(log.metadata))]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "emd-card-grid__row" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "emd-card-grid__column" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "emd-text _type_label _size_tiny _color_nonessential",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("log-actions.list.name")
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "emd-card-grid__line",
                                          },
                                          [_vm._v(_vm._s(log.user_name || "-"))]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "emd-card-grid__column" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "emd-text _type_label _size_tiny _color_nonessential",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("log-actions.list.email")
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "emd-card-grid__line",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(log.user_email || "-")
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "emd-card-grid__column" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "emd-text _type_label _size_tiny _color_nonessential",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "log-actions.list.origin-id"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "emd-card-grid__line",
                                          },
                                          [_vm._v(_vm._s(log.key || "-"))]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "emd-card-grid__column" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "emd-text _type_label _size_tiny _color_nonessential",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("log-actions.list.ip")
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "emd-card-grid__line",
                                          },
                                          [_vm._v(_vm._s(log.ip || "-"))]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "emd-card-grid__column _size_100",
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "emd-text _type_label _size_tiny _color_nonessential",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("log-actions.list.agent")
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "emd-card-grid__line",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(log.user_agent || "-") +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          _vm.showEmptyList()
                            ? _c("empty-list", { attrs: { entity: "logs" } })
                            : _vm._e(),
                          _vm.showEmptyListFilter()
                            ? _c("empty-list-filter", {
                                attrs: { entity: "logs" },
                              })
                            : _vm._e(),
                          !_vm.loadingList
                            ? _c("pagination", {
                                attrs: {
                                  pagination: _vm.logActions,
                                  totalShowing: _vm.totalItems,
                                  type: "dynamic",
                                  action: _vm.action,
                                },
                              })
                            : _vm._e(),
                        ],
                        2
                      ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }